import { Injectable } from '@angular/core';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttperrorhandlerService } from 'src/app/common/http/httperrorhandler.service';
import {SessionStorageService} from 'angular-web-storage';
import { CookieService } from 'ngx-cookie-service';
import { EncdecService } from '../encdec.service';
import { Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthloginService {
  ipAddress: any;
  userdetails: any;
  usrdetail: any;

  constructor(private constants : ConstantsModule,
    private http : HttpClient,
    private errorHandler: HttperrorhandlerService,
    private session: SessionStorageService,
    private encdec  : EncdecService,
    private cookie : CookieService,
    private router : Router) { }

  getcaptchaimageapi(){
    return this.constants.API_URL_USER+"api/captcha/fetch";
  }
  getuserlogin(options: object): Observable<any>{
    options['ipAddress'] = this.ipAddress;
    let loginuser = "login-with-encryption";
    return this.http.post<any>(this.constants.API_URL_USER + loginuser, options,{withCredentials :true})
  }
  getIPAddress() {
    let ip1, ip2, ip3;
    this.http.get("https://ipecho.net/plain", { responseType: 'text' }).subscribe((res: any) => {
      ip1 = res;
      this.ipAddress = ip1;
      console.log("ip1", ip1);

      if (ip1 == null || ip1 == "" || ip1 == undefined || ip1 === "") {
        this.http.get("https://api.ipify.org", { responseType: 'text' }).subscribe((res: any) => {
          ip2 = res;
          this.ipAddress = ip2;
          console.log("ip2", ip2);

          if (ip2 == null || ip2 == "" || ip2 == undefined || ip2 === "") {
            this.http.get("https://myexternalip.com/raw", { responseType: 'text' }).subscribe((res: any) => {
              ip3 = res;
              this.ipAddress = ip3;
              console.log("ip3", ip3)
            });
          }
        });
      }
    });    

    // console.log("finl IP", this.ipAddress);
  }
  logoutuser(): Observable<any>{
    this.userdetails = this.checkloginstatus(); 
    this.usrdetail = this.userdetails['loggedUserData']['userProfile'];
    this.usrdetail['ipAddress'] = this.ipAddress;
    this.usrdetail['loginTs'] = this.userdetails['loginTs'];
    // let options ={
    //   "userDetails": String(this.usrdetail),
    //   "ipAdress":this.ipAddress
    // }   
    let logoutuser = "logout";
    return this.http.post<any>(this.constants.API_URL_USER + logoutuser, this.usrdetail,this.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('logout user', []))
    );
  }
  logoutuserandsessionclear(){
    let url  = this.router.url; 
    this.logoutuser().subscribe(res =>{
      if(res.result.success){
        this.clearsession();
        if(url.search('submitdata') != -1){
          this.router.navigate(["/gis"]);
        }else{
          setTimeout(() => { location.reload(); }, 10);
        }
      }
    });
  }
  reset(options: object): Observable<any>{
    let reset = "reset-otp-enc-password";
    return this.http.post<any>(this.constants.API_URL_USER + reset, options,{withCredentials:true})
  }

  clearusersession(){
    localStorage.removeItem('userdetails');
  }

  clearsession(){
    localStorage.removeItem('USERID');
    localStorage.removeItem('USER_INFO');
    localStorage.removeItem('USER_DETAILS_INFO');
    localStorage.removeItem('userdetails');
  }
  createsession(userdetails){
    localStorage.setItem('userdetails',JSON.stringify(userdetails));
  }

  checkloginstatus(){
    return localStorage.getItem('userdetails') ? JSON.parse(localStorage.getItem('userdetails')) : null;
  }
  checkuserforresetpwd(options : object) : Observable<any>{
    let checkreset = "send-email-otp";
    return this.http.post<any>(this.constants.API_URL_USER + checkreset, options,{withCredentials :true})
  }

  changeUserPassword(passwordHash : any):Observable<any>{
    let postdata = {
      passwordHash,
      token: localStorage.getItem('ACCESS_TOKEN'),
      }
    return this.http.post<any>(this.constants.API_URL_USER + "/change-users-password", postdata,this.getHeadersWithCsrf());
  }

   getHeadersWithCsrf(api?: string) {
    const options = { headers: {},withCredentials:true}
    options.headers['Content-Type'] = 'application/json';
    options.headers['Access-Control-Allow-Origin'] = "https://gdpms.mowr.gov.in";
    if(this.cookie.get('csrf_token')){
      options.headers['X-CSRF-TOKEN'] = this.cookie.get('csrf_token')
    }

    return options;
  }
}
